<template>
  <div>
    <el-card class="box-card-left">
      <template slot="header">
        <span style="font-size: 14px">折线图</span>
      </template>
      <div id="main" class="line-chart"></div>
    </el-card>
    <el-card class="box-card-left">
      <template slot="header">
        <span style="font-size: 14px">饼图</span>
      </template>
      <div id="main-pie-chart" class="pie-chart"></div>
    </el-card>
    <el-card class="box-card-left">
      <template slot="header">
        <span style="font-size: 14px">柱状图</span>
      </template>
      <div id="main-histogram" class="histogram"></div>
    </el-card>
    <el-card class="box-card-left">
      <template slot="header">
        <span style="font-size: 14px">柱状图?同比环比</span>
        <el-date-picker
          style="float: right; margin-bottom: 5px"
          v-model="value3"
          type="year"
          placeholder="选择年份"
          value-format="yyyy"
        />
      </template>
      <div id="main-histogram-1" class="histogram"></div>
    </el-card>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  DatasetComponent,
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import { LineChart, PieChart, BarChart } from "echarts/charts";
import { UniversalTransition, LabelLayout } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";

export default {
  name: "financialChartIndex",
  data() {
    return {
      value3: String(new Date().getFullYear()),
    };
  },
  mounted() {
    this.lineChart();
    this.pieChart();
    this.histogram();
    this.histogram2();
  },
  methods: {
    lineChart() {
      echarts.use([
        GridComponent,
        LineChart,
        CanvasRenderer,
        UniversalTransition,
      ]);
      var chartDom = document.getElementById("main");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            smooth: true,
          },
        ],
      };

      option && myChart.setOption(option);
    },
    pieChart() {
      echarts.use([
        TitleComponent,
        TooltipComponent,
        LegendComponent,
        PieChart,
        CanvasRenderer,
        LabelLayout,
      ]);

      var chartDom = document.getElementById("main-pie-chart");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: "Referer of a Website",
          subtext: "Fake Data",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: "50%",
            data: [
              { value: 1048, name: "Search Engine" },
              { value: 735, name: "Direct" },
              { value: 580, name: "Email" },
              { value: 484, name: "Union Ads" },
              { value: 300, name: "Video Ads" },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    histogram() {
      echarts.use([GridComponent, BarChart, CanvasRenderer]);

      var chartDom = document.getElementById("main-histogram");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: "bar",
          },
        ],
      };

      option && myChart.setOption(option);
    },
    histogram2() {
      echarts.use([
        DatasetComponent,
        TooltipComponent,
        GridComponent,
        LegendComponent,
        BarChart,
        CanvasRenderer,
      ]);

      var app = {};

      var chartDom = document.getElementById("main-histogram-1");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        legend: {},
        tooltip: {},
        dataset: {
          source: [
            ["product", "2021", "2022"],
            ["Matcha Latte", 43.3, 85.8],
            ["Milk Tea", 83.1, 73.4],
            ["Cheese Cocoa", 86.4, 65.2],
            ["Walnut Brownie", 72.4, 53.9],
          ],
        },
        xAxis: { type: "category" },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [{ type: "bar" }, { type: "bar" }],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>

<style>
.box-card-left {
  width: 49.5%;
  margin-top: 5px;
  margin-left: 0.5%;
  float: left;
}

.line-chart {
  width: 100%;
  height: 300px;
}
.pie-chart {
  width: 100%;
  height: 300px;
}
.histogram {
  width: 100%;
  height: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/FinancialChart/index.vue